/**
 * Created by felix on 18/11/2020.
 */

import {EMPTY, LOADING, READY, ERROR} from 'module/constants';
import common from 'module/common';

const SET_STATE = 'state';
const SET_PRESET_PACKS = 'setPresetPacks';

// initial state
const state = {
  state: EMPTY,
  presetPacks: []
};

//actions
const actions = {
  load({state, dispatch, commit, rootGetters}) {
    if(['portal'].includes(rootGetters['environment/route']) === false){
      //Not needed for this environment
      return;
    }

    commit(SET_STATE, LOADING);
    
    let idToken = rootGetters['user/idToken']();
  
    common
        .httpGet('reportsPackSettings')
        .idToken(idToken || null)
        .then((res) => {
          commit(SET_STATE, READY);
          commit(SET_PRESET_PACKS, res.data);
        }, ({data}) => {
          commit(SET_STATE, ERROR);
        });
  }
};

//getters
const getters = {};

// mutations
const mutations = {
  [SET_STATE](state, newState) {
    state.state = newState;
  },
  [SET_PRESET_PACKS](state, presetPacks) {
    state.presetPacks = presetPacks;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}